var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload" }, [
    _c("div", { staticClass: "control" }, [
      _c(
        "div",
        {
          staticClass:
            "upload__select p1 t-dark-grey lh-reset bg-white px-1 px-sm-2 py-2"
        },
        [
          _c(
            "file-upload",
            {
              ref: "upload",
              staticClass: "file-upload",
              attrs: {
                "post-action": _vm.postFoo(),
                extensions: "gif,jpg,jpeg,png,webp,pdf",
                accept:
                  "image/png,image/gif,image/jpeg,image/webp,application/pdf",
                multiple: true,
                size: 1024 * 1024 * 10
              },
              on: {
                "input-filter": _vm.inputFilter,
                "input-file": _vm.inputFile
              },
              model: {
                value: _vm.files,
                callback: function($$v) {
                  _vm.files = $$v
                },
                expression: "files"
              }
            },
            [_vm._v("\n                Choose files\n            ")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "control" }, [
      !_vm.$refs.upload || !_vm.$refs.upload.active
        ? _c(
            "button",
            {
              staticClass: "btn btn-upload",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.$refs.upload.active = true
                }
              }
            },
            [_vm._v("Start Upload\n        ")]
          )
        : _c(
            "button",
            {
              staticClass: "btn btn-upload",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.$refs.upload.active = false
                }
              }
            },
            [_vm._v("Stop Upload")]
          )
    ]),
    _vm._v(" "),
    _vm.files.length
      ? _c("div", { staticClass: "upload__files mt-4" }, [
          _c("div", { staticClass: "t-navy lh-lg mb-1" }, [
            _vm._v("Files to upload")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "files t-navy rows" },
            [
              _vm._l(_vm.files, function(file, index) {
                return _c(
                  "li",
                  {
                    key: file.id,
                    staticClass:
                      "file odd row px-1 px-sm-3 py-12px t-navy w-100"
                  },
                  [
                    _c("div", { staticClass: "d-flex w-100" }, [
                      _c(
                        "div",
                        { staticClass: "column p-0 file__name fs-18 py-12px" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "column p-0 file__btn text-right" },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: { el: "#confirmDelete", offset: -120 },
                                  expression:
                                    "{el: '#confirmDelete',offset: -120}"
                                }
                              ],
                              staticClass: "btn btn-ghost btn-small w-100 p-1",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.confirmDelete(file, index)
                                }
                              }
                            },
                            [_vm._v("Delete")]
                          )
                        ]
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.showConfirm
                ? _c(
                    "li",
                    {
                      staticClass: "file row px-1 px-sm-3 py-12px t-navy w-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex w-100 align-items-center",
                          attrs: { id: "confirmDelete" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "column is-8 font-weight-light p-0 py-12px"
                            },
                            [
                              _vm._v(
                                "\n                        Are you sure you want to delete "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.fileToDelete.name))
                              ]),
                              _vm._v("?\n                    ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "column p-0 buttons text-right" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-ghost btn-small btn-small--navy w-100 p-1 mr-sm-2 mb-2 mb-sm-0",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.keepFile()
                                    }
                                  }
                                },
                                [_vm._v("Keep")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-ghost btn-small w-100 p-1",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.deleteFile()
                                    }
                                  }
                                },
                                [_vm._v("Delete")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57c2664e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c2664e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Uploader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-57c2664e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Uploader.vue
// module chunks = 0 1